import gql from 'graphql-tag';

export default gql`
  mutation updateArtwork($input: UpdateArtworkInput!) {
    updateArtwork(input: $input) {
      id
      status
      creatorVersion
      animationHasAlpha
      animationVideoOrientation
      redirectLaunchV3
      modified
    }
  }
`;
